import styles from '@cp/pages/Paramount/Documentation/styles.module.scss';
import React from 'react';

function Trigger() {
  return (
    <div className={styles.documentationContainer}>
      <h2>Trigger</h2>
      <p>
        <strong>Definition</strong>: Defines instant actions to be taken on cases as soon as they
        meet a certain condition.
      </p>
      <p>
        <strong>Purpose</strong>:
      </p>
      <ul>
        <li>Associated with a timeline.</li>
        <li>Timelines can have multiple triggers.</li>
        <li>Triggers are anchored on the anchor date of the timeline.</li>
        <li>Specifies conditions, pre-actions, and actions for execution.</li>
      </ul>
      <p>
        <strong>Creating a Trigger</strong>:
      </p>
      <pre>
        <code>
          {`trigger "DuePaidTrigger" {
  timeline = "PLCollectionsTimeline"
  description = "Sample trigger description"
  condition_type = "EVENT_BASED"
  condition = "DuePaidEvent"
  actions = {
  SEND_COMMUNICATION {
  time = "09:30"
  communication_type = "SMS"
}
}}`}
        </code>
      </pre>
      <p>
        <strong>Trigger Field Explanation:</strong>
      </p>
      <ul>
        <li>
          <strong>timeline</strong>: Timeline name of which this trigger is part.
        </li>
        <li>
          <strong>description</strong>: Human-readable description of the Trigger.
        </li>
        <li>
          <strong>condition_type</strong>: Defines the condition parsing engine to use for
          evaluating the trigger. Currently supports EVENT_BASED.
        </li>
        <li>
          <strong>condition</strong>: Defines the condition on the trigger on which the Trigger has
          to be applied.
        </li>
        <li>
          <strong>actions</strong>: Contains actions to execute as part of this trigger. All
          executions will be carried out in the specified order; if any action fails, subsequent
          actions will not be executed.
        </li>
      </ul>
    </div>
  );
}

export default Trigger;
